export const MIN_WIDTH_FOR_FILTERS_STYLE = 700;
